<header id="header" class="top_header">
  <nav class="nav_header">
    <div class="nav_div">
      <div class="idp_now">{{ (env.name && ['dev', 'stage'].includes(env.name)) ? ('MyIDPNow' + ' - ' + env.name) : 'MyIDPNow' }} </div>
      <div class="header_right_group">
        @if (institutionName()) {
          <div class="grn_tg pr_nme_menu_dd ng-tns-c13-0 institution_status {{institutionStatus() | lowercase}}" [title]="institutionName()">{{institutionName()}}</div>
        }
        @if(userLogoDetail() && userData) {
          <div class="search_icon" (click)="openQuickSearchPopup()"><img [src]="imageConstants.searchIcon" alt="search icon"></div>
        }
        <div id="userDrpId" class="hd_rgt ng-tns-c13-0 ng-star-inserted" [ngClass]="{'show_user_top_menu' : userMenuFlag() }" tabindex="-1" (focus)="userMenuFlag.set(true)" (focusout)="userMenuFlag.set(false)">
          @if (userLogoDetail() && userData) {
            <div class="prof_cnr ng-tns-c13-0">
              <button class="usr ng-tns-c13-0" (click)="hideShowTopNavMenu()">
                <span class="prof_cir ng-tns-c13-0">{{userLogoDetail()}}</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="Media / Icon">
                    <path id="Icon" d="M18 9.5L12 15.5L6 9.5" stroke="#555555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                </svg>
              </button>
              <div class="usr_drp ng-tns-c13-0">
                <div class="nav_cl1 ng-tns-c13-0">
                  <p class="udrl cr_dlt ng-tns-c13-0">{{userDetails().given_name}} {{userDetails().family_name}}
                    <!-- <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="user_menu_arrow"
                    [class.rotate-up]="userDetailsFlag" (click)="userDetailsFlag=!userDetailsFlag">
                    <g id="Media / Icon">
                      <path id="Icon" d="M18 9.5L12 15.5L6 9.5" stroke="#555555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                  </svg> -->
                </p>
                <div class="user_details" class="show_user_details">
                  <div class="user_info">
                    <label for="html" class="name_dets">First name:</label><span class="form_name">{{userDetails().given_name}}</span><br>
                  </div>
                  <div class="user_info">
                    <label for="html" class="name_dets">Last name:</label><span class="form_name">{{userDetails().family_name}}</span><br>
                  </div>
                  <div class="user_info">
                    <label for="html" class="name_dets">Email address:</label><span class="form_name large_text">{{userDetails().email}}</span><br>
                  </div>
                  @if (userData) {
                    <div class="user_info">
                      <label for="html" class="name_dets">User role:</label><span class="form_name">{{userData.roleName}}</span>
                    </div>
                  }
                </div>
                @if (institutionName()) {
                  <div class="grntag_cnr ng-tns-c13-0">
                    <span class="grn_tg pr_nme_menu_dd ng-tns-c13-0 {{institutionStatus() | lowercase}}" [title]="institutionName()">{{institutionName()}}</span>
                    <a title="select different institution to manage" class="btn_link mr_l_0 ng-tns-c13-0" (click)="manageAnotherInstitution()">Change</a>
                  </div>
                }
              </div>
              <div class="border_btm"></div>
              <ul class="prof_menu ng-tns-c13-0">
                <li class="ng-tns-c13-0 ng-star-inserted manage_detail">
                  <a title="Select different institution to manage" class="ng-tns-c13-0" (click)="redirectToInstListPage()">View all institutions</a>
                </li>
                <div class="border_btm"></div>
                <li class="log_out ng-tns-c13-0" (click)='util.userSignOut()' ><a title="Sign out" class="ng-tns-c13-0">Sign out</a>
              </li>
            </ul>
          </div>
        </div>
      }
    </div>
  </div>
</div>
</nav>
</header>
